<link rel='stylesheet prefetch'
  href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.6.2/css/font-awesome.min.css'>

<div id="frame">
  <div class="content">
    <div class="messages" id="scrollChat" #scrollChat (scroll)="onScroll()">
      <ul class="messagewindow" *ngFor="let msg of chatHistory">

        <li *ngIf="msg.userType == session.me.userType" class="replies">
          <img *ngIf="session.me.profileImage != null" [src]="session.me.profileImage">
          <p [ngClass]="{'client-im-msg': session.me.userType == 301, 'pro-im-msg': session.me.userType == 302}">
            {{msg.message}}
          </p>
        </li>

        <li *ngIf="msg.userType != this.session.me.userType" class="sent">
          <img *ngIf="session.otherParty.profileImage != null" [src]="session.otherParty.profileImage">
          <p [ngClass]="{'client-im-msg': session.otherParty.userType == 301, 'pro-im-msg': session.otherParty.userType == 302}">
            {{msg.message}}
          </p>
        </li>

      </ul>
    </div>

    <div class="message-input">
      <div *ngIf="comms.isOtherPartyTyping" class="sending-notif-wrap">Typing...</div>
      <div *ngIf="sendingMessage" class="sending-notif-wrap">Sending Message...</div>
      <div class="wrap">
        <input type="text" placeholder="Write your message..." [(ngModel)]="messagebox"
          (keydown)="enterSendMessage($event)" />
        <button class="submit" id="submit" (click)="sendMessage()"><i class="fa fa-paper-plane"
            aria-hidden="true"></i></button>
      </div>
    </div>
  </div>
</div>

<script>
  $(function () {
    $("#submit").click(function () {
      $('#scrollChat').animate({
        scrollTop: $('#scrollChat')[0].scrollHeight
      }, "slow");
    });
  });

</script>
